module.exports = {"510704001":"涪江街道","510704003":"富乐街道","510704004":"游仙街道办","510704006":"春雷街道","510704007":"松林街道","510704008":"华丰街道","510704101":"石马镇","510704102":"新桥镇","510704103":"小枧沟镇","510704104":"魏城镇","510704105":"沉抗镇","510704106":"忠兴镇","510704107":"柏林镇","510704108":"徐家镇","510704109":"石板镇","510704110":"刘家镇","510704111":"玉河镇","510704112":"松垭镇","510704113":"白蝉镇","510704114":"观太镇","510704115":"云凤镇","510704116":"太平镇","510704117":"街子镇","510704118":"东林镇","510704119":"梓棉镇","510704120":"东宣镇","510704202":"建华乡","510704207":"朝真乡","510704210":"凤凰乡","510704400":"四川省新华劳动教育管理所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510704.json
// module id = 2301
// module chunks = 0